import { Navigate, useLocation } from 'react-router-dom';

/**
 * OpenTok was removed (VideoSDK only). Old /telehealth/call links go to the
 * preview, which starts the VideoSDK call. The query (appointmentId) is kept
 * and history is replaced so Back doesn't bounce through this URL.
 */
const LegacyCallRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/telehealth${search}`} replace />;
};

export default LegacyCallRedirect;
